<template>
  <base-nav
    container-classes="container-fluid"
    class="navbar-top border-bottom navbar-expand"
    :class="{ 'bg-success navbar-dark': type === 'default' }"
  >
    <ul class="navbar-nav align-items-center ml-md-auto" style="width: 100%">
      <li class="nav-item d-xl-none">
        <!-- Sidenav toggler -->
        <div
          class="pr-3 sidenav-toggler"
          :class="{
            active: $sidebar.showSidebar,
            'sidenav-toggler-dark': type === 'default',
            'sidenav-toggler-light': type === 'light',
          }"
          @click="toggleSidebar"
        ></div>
      </li>
      <li>
        <h2 class="mb-0" style="color: white">Teaching & training platform</h2>
      </li>
    </ul>
    <ul
      class="navbar-nav align-items-center ml-auto ml-md-0"
      style="width: 30%; text-align: right"
    >
      <base-dropdown
        menu-on-right
        class="nav-item"
        tag="li"
        title-tag="a"
        title-classes="nav-link pr-0"
      >
        <a href="#" class="nav-link pr-0" @click.prevent slot="title-container">
          <div class="media align-items-center">
            <span class="avatar avatar-sm rounded-circle">
              <img
                class="profile-picture-sm"
                alt="Image placeholder"
                :src="$store.getters.profilephoto"
              />
            </span>
            <div
              class="media-body ml-2 d-none d-lg-block"
              style="padding-left: 5px"
            >
              <span class="mb-0 text-sm font-weight-bold">{{
                $store.state.user.fullname
              }}</span>
            </div>
          </div>
        </a>

        <template>
          <div class="dropdown-header noti-title">
            <h6 class="text-overflow m-0">Welcome!</h6>
          </div>

          <router-link
            :to="{
              name: 'StudentProfile'
            }"
            class="dropdown-item"
          >
            <i class="ni single-04"></i>
            <span>My profile</span>
          </router-link>
          <router-link :to="{ name: 'StudentChangePassword' }" class="dropdown-item">
            <i class="ni settings-gear"></i>
            <span>Change password</span>
          </router-link>

          <div class="dropdown-divider"></div>
          <router-link :to="{ name: 'Logout' }" class="dropdown-item">
            <i class="ni logout"></i>
            <span>Logout</span>
          </router-link>
        </template>
      </base-dropdown>
    </ul>
  </base-nav>
</template>
<script>
import { CollapseTransition } from "vue2-transitions";
import { BaseNav, Modal } from "@/components";

export default {
  name: "student-dashboard-navbar",
  components: {
    CollapseTransition,
    BaseNav,
    Modal,
  },
  props: {
    type: {
      type: String,
      default: "default", // default|light
      description:
        "Look of the dashboard navbar. Default (Green) or light (gray)",
    },
  },
  computed: {
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
  },
  data() {
    return {
      activeNotifications: false,
      showMenu: false,
      searchModalVisible: false,
      searchQuery: "",
    };
  },
  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
  },
  mounted() {},
};
</script>
<style scoped>
.profile-picture-sm {
  width: 50px;
  height: 50px;
}
</style>